import { FC, Fragment, JSX } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { AddRounded as AddRoundedIcon } from '@mui/icons-material';
//components
import { useNavigate } from 'react-router-dom';
import CapsuleTypeTable from './CapsuleTypeTable';
// constant, styles, reducer, graphql
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { ADD_CAPSULE_TYPE_ROUTE, ADD_NEW_TEXT, CAPSULE_TYPE_TEXT } from 'constants/index';

const CapsuleType: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{CAPSULE_TYPE_TEXT}</Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(ADD_CAPSULE_TYPE_ROUTE)}
          startIcon={<AddRoundedIcon />}>
          {ADD_NEW_TEXT}
        </Button>
      </Box>
      <CapsuleTypeTable />
    </Fragment>
  );
};

export default CapsuleType;
